module.exports = __webpack_public_path__ + "static/bg-sidebar-finance-calculator-c6bdc868f2e445bfe258a8c8188d123c.svg";